const SearchModal = (target) => {
  const $body = $('body')
  const initModal = el => {
    const params = {}
    const linkEl = el.querySelector('.search-modal__button')
    let url = new URL(linkEl.href)
    const $searchInput = $(el).find('.search__input')

    const updateLink = (params) => {
      const searchParams = new URLSearchParams(url.searchParams)
      for (let key in params) {
        searchParams.forEach((s_value, s_key) => {
          if (key === s_key && s_value !== params[key]) {
            searchParams.delete(key)
          }
        })

        if (params.hasOwnProperty(key)) {
          searchParams.set(key, params[key])
        }
      }
      url.search = searchParams.toString()
    }

    $(el).find('.custom-checkbox__input').on('change', e => {
      const target = e.currentTarget
      const name = target.name
      params[name] = $(`input[name="${name}"]:checked`).map(function () {
        return this.value
      }).get().join(',')
      updateLink(params)
    })

    const searchAction = () => {
      const value = $searchInput.val()
      if (value !== '') {
        const name = $searchInput.attr('name')
        params[name] = value
        updateLink(params)
      }
      window.location.assign(url.href)
    }

    linkEl.addEventListener('click', evt => {
      evt.preventDefault()
      searchAction()
    })

    $searchInput.keypress((e) => {
      if (e.which === 13) {
        searchAction()
      }
    })
  }

  const $target = $body.find(target)
  const $burger = $body.find('.burger-menu')
  const $header = $body.find('header.main-header')

  $target.each((_, el) => {
    initModal(el);
  })

  $body.find('.search-modal__trigger').on('click', e => {
    e.preventDefault()
    $target.removeClass('hidden')
    $burger.addClass('hidden')
    $header.addClass('fixed')
    $body.addClass('overflow-hidden')
  })

  $body.find('.close-modal__trigger').on('click', e => {
    e.preventDefault()
    $target.addClass('hidden')
    $burger.removeClass('hidden')
    $header.removeClass('fixed')
    $body.removeClass('overflow-hidden')
  })
}

export default SearchModal;



// WEBPACK FOOTER //
// ./scripts/components/SearchModal.js